import "./style.css";

export default class Hero {
  static selector = ".hero";

  constructor(block) {
    this.block = block;

    this.videoIframe = this.block.querySelector(".hero__video");
    this.videoIframeWrapper = this.block.querySelector(".hero__video-wrapper");
    this.lazyImage = this.block.querySelector(".lazy");

    this.isLoaded = false;
  }

  handleLoaded = () => {
    this.isLoaded = true;
    this.videoIframeWrapper.classList.add("is-loaded");
    this.lazyImage.classList.add("is-hidden");
  };

  onReady() {
    if(this.videoIframe.tagName == 'iframe') {
      this.videoIframe.src = this.videoIframe.src;
      this.videoIframe.addEventListener("load", this.handleLoaded, true);  
    } else {
      if(!this.videoIframe.paused) {
        this.handleLoaded();
      } else {
        this.videoIframe.addEventListener("play", this.handleLoaded, true);
      }
      
    }
  }

  onDestroy() {
    this.videoIframe.removeEventListener("load", this.handleLoaded);
  }
}
